import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import BackButton from 'containers/SubmitDocuments/steps/BackButton'
import CongratulationMessage from 'containers/SubmitDocuments/steps/CongratulationMessage'
import DocumentVerificationStep from 'containers/SubmitDocuments/steps/DocumentVerificationStep'
import IdVerificationStep from 'containers/SubmitDocuments/steps/IdVerificationStep'
import content from 'prismic-translates/page-identity-verification.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  isRedeeming: boolean
  kycRequired: boolean
}

export default function IdentityVerification(props: Props) {
  return (
    <div className={classes.root}>
      <CongratulationMessage />
      <IdVerificationStep isRedeeming={props.isRedeeming} verificationFrom='account' />
      <DocumentVerificationStep isRedeeming={props.isRedeeming} verificationFrom='account' />
      <BackButton />
      <footer className={classes.footer}>
        <span className={classes.footerText}>
          {t('footer_text')}{' '}
          <a href={`${process.env.ZENDESK_VERIFICATION_LINK}`} target='_blank' rel='noreferrer'>
            {t('footer_text_link')}
          </a>
        </span>
      </footer>
    </div>
  )
}
